export function handleResponse(response) {
  return response.text().then(text => {

    if (!response.ok) {

      if (response.status === 401) {
        // auto logout if 401 response returned from api
        //commit('registerFailure', error);
        localStorage.removeItem('user');
        //location.reload(true);
      }


      /*
      if (response.status === 500) {

        // auto logout if 401 response returned from api
        //commit('registerFailure', error);
        localStorage.removeItem('user');
        location.reload(true);
      }*/

      const data = text && JSON.parse(text);
      const error = (data && data.message) || response.statusText;

      return Promise.reject(data);
    }

    const data = text && JSON.parse(text);

    return data;

  });
}
